// extracted by mini-css-extract-plugin
export default {"container":"StakingPosition_container__-Kui5","airdrop":"StakingPosition_airdrop__CPUdc"};